var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cheng-shu',{staticStyle:{"position":"relative","top":"-15px"},attrs:{"task_id":_vm.task_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }